import React from "react";
import styles from "./Soon.module.css";

export function CommingSoon() {
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.container_div}>
          <p className={styles.text}>Comimg Soon...</p>
        </div>
      </div>
    </div>
  );
}
